import './modules/jquery.ui.js';
import './modules/jquery.ui.touch-punch.js';
import 'backbone.basicauth/backbone.basicauth.js';
import '../jquery-plugins/jquery.inkive.common.js';
import './js.overrides.js';
import '../api.js';
import './core/pathseg.js';
import './core/jquery.svg.js';
import './core/browser.js';
import './core/svgtransformlist.js';
import './core/math.js';
import './core/units.js';
import './core/svgutils.js';
import './core/sanitize.js';
import './core/history.js';
import './core/coords.js';
import './core/recalculate.js';
import './core/select.js';
import './core/draw.js';
import './core/path.js';
import './core/touch.js';
import './core/svgcanvas.js';
import './core/history/batchCommand.js';
import './core/history/changeCommand.js';
import './core/history/insertElementCommand.js';
import './core/history/moveElementCommand.js';
import './core/history/removeElementCommand.js';
import './math.js';
import 'bootstrap-daterangepicker/daterangepicker.js';
import 'indexeddbshim/dist/indexeddbshim.js';
import 'jquery-contextmenu/dist/jquery.contextMenu.js';
import '../fineuploader-5.4.1/s3.jquery.fine-uploader.js';
import '../jquery-plugins/jquery.transit.editor.js';
import '../jquery-plugins/jquery-ui-slider-pips.js';
import '../jquery-plugins/slick.js';
import '../bootstrap-typeahead.js';
import '../util/antiscroll.editor.js';
import '../bootstrap.editor.js';
import './modules/bootstrap-tagsinput.js';
import './core/js-hotkeys/jquery.hotkeys.min.js';
import './core/jquery.browser.js';
import './jquery.overrides.editor.js';
import './modules/jpicker.js';
import './modules/ZeroClipboard.js';
import './modules/jquery.zeroclipboard.js';
import '../jquery-plugins/jquery.fontSpy.js';
import '../redirect-on-lacking-support.js';
